import React,{useState} from 'react'
import { Button } from '../../button/Button'
import crown from '../../../assets/crown.png'
import Topup from '../../topup/Topup'


const TermsPay = ({onPay}) => {

    const [showTopup,setShowTopup] = useState(false)

    const handleShowTopup = () => {
        setShowTopup(true)
    }

    const close = () => {
        setShowTopup(false)
    }

    return (
        <>
            <div className="terms__content-payment-price">
                <div className="terms__content-payment-price-wrap">
                    <p>Price</p>
                    <div className="terms__content-payment-price-token">
                        <img src={crown} alt="crown"/>
                        <p>100</p>
                    </div>
                    <Button buttonColor="green" buttonSize="btn--wide" onClick={onPay}>PAY</Button>
                </div>
            </div>

            <div className="terms__content-payment-topup">
                <div className="terms__content-payment-topup-token">
                    <p>You Need 75</p>
                    <img src={crown} alt="crown"/>
                </div>
                <Button buttonColor="orange" buttonSize="btn--small" onClick={handleShowTopup}>TOPUP NOW</Button>
            </div>

            {showTopup && <Topup onClose={close}/>}

        </>
    )
}

export default TermsPay
